export default __webpack_public_path__ + "static/media/bed.5dd3e406.svg";